import {
  getV1CompaniesCompanyIdMaterialTypes,
  GetV1CompaniesCompanyIdUsersTypeaheadData,
  MaterialType_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { MAX_API_PAGE_SIZE } from '~constants/consts';
import { MaterialTypeItem } from '~hooks/useMaterials/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  MaterialType_Read,
  MaterialTypeItem,
  GetV1CompaniesCompanyIdUsersTypeaheadData
> & { companyId: string };

export default function AutocompleteMaterialTypes<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteMaterialTypes"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId },
          query: { 'page[limit]': MAX_API_PAGE_SIZE },
        },
        request: getV1CompaniesCompanyIdMaterialTypes,
      }}
      parseFn={(item: MaterialType_Read) => {
        const parsed = MaterialTypeItem.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
